import { useMutation, useQuery } from "react-query";
import { GET, POST } from "../../../../Services";
import { notification } from "antd";

export const useSelectRequerimientoPokemon = () => {
  return useQuery(
    ["selectRequerimientoPokemon"],
    async () => {
      const response = await GET("pokemon/selectRequerimientoPokemon");
      return response;
    }
  );
};

// Nuevo hook para obtener las evoluciones existentes de un Pokémon
export const useListarEvolucionesPokemon = (params = null) => {
  return useQuery(
    ["listarEvolucionesPokemon", params],
    async () => {
      const response = await GET(
        "pokemon/evolucionesPokemon",
        `?${new URLSearchParams(params).toString()}`
      );
      if (!response) {
        throw new Error("Error al listar evoluciones");
      }
      return response;
    },
    {
      enabled: !!params?.idPokemon, // Solo ejecuta si hay idPokemon
      retry: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (error) => {
        notification["error"]({
          message: "Error al intentar listar evoluciones del Pokémon",
        });
      },
    }
  );
};

export const useAsignarRequerimientoEvolucion = () => {
  return useMutation(
    async (data) => await POST(data, "pokemon/AsignarRequerimientoEvolucion"),
    {
      onSuccess: () => {
        notification["success"]({ message: "Requerimiento asignado" });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ message: "Error al asignar requerimiento" });
        }
      },
    }
  );
};

// Nuevo hook para eliminar una evolución
export const useEliminarEvolucionPokemon = () => {
  return useMutation(
    async (evolucionId) => await POST({idReqPok: evolucionId},`pokemon/eliminarEvolucion`),
    {
      onSuccess: () => {
        notification["success"]({ message: "Evolución eliminada correctamente" });
      },
      onError: (error) => {
        if (error.response && error.response.data?.datos) {
          notification["error"]({ message: error.response.data.datos });
        } else {
          notification["error"]({ message: "Error al eliminar evolución" });
        }
      },
    }
  );
};
